import type { IncidentDomainResponse } from '@prerender/diagnostics-api';

import { LastMeasuredNote } from './CrawlerEvidence';
import { isRecovered } from './originBlockingFigures';

type EvidenceNotesProps = {
  domains: readonly IncidentDomainResponse[];
  isReadable: (evidence: Record<string, unknown>) => boolean;
};

const unreadableNoteOf = (count: number): string => `Figures unavailable for ${count} ${count === 1 ? 'domain' : 'domains'}`;

function EvidenceNotes({ domains, isReadable }: EvidenceNotesProps) {
  const unreadableDomainCount = domains.filter(({ evidence }) => !isReadable(evidence)).length;

  return (
    <>
      {domains.every(isRecovered) && <LastMeasuredNote />}
      {unreadableDomainCount > 0 && <p className="diagnostics-evidence-note">{unreadableNoteOf(unreadableDomainCount)}</p>}
    </>
  );
}

export default EvidenceNotes;
